<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    id="Duotone"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 112">
    <title>01- convenience-store</title>
    <g id="Icons">
      <g id="Background">
        <path
          class="cls-1"
          d="M90.5,56A40,40,0,1,0,14.06,72.5H86.94A39.85,39.85,0,0,0,90.5,56Z" />
        <line
          class="cls-2"
          x1="11.5"
          y1="72.5"
          x2="89.5"
          y2="72.5" />
        <line
          class="cls-2"
          x1="7"
          y1="72.5"
          x2="9.5"
          y2="72.5" />
        <line
          class="cls-2"
          x1="91.5"
          y1="72.5"
          x2="94"
          y2="72.5" />
      </g>
      <g id="Scene">
        <path
          class="cls-3"
          d="M72.4,54a3.3,3.3,0,0,1-3.3-3.3,3.3,3.3,0,0,1-6.6,0,3.3,3.3,0,1,1-6.6,0,3.3,3.3,0,1,1-6.6,0,3.3,3.3,0,0,1-6.6,0,3.3,3.3,0,0,1-6.6,0A3.29,3.29,0,0,1,32.8,54a3.68,3.68,0,0,1-.66-.06V72.47H73.06V53.93A3.52,3.52,0,0,1,72.4,54Z" />
        <path
          class="cls-3"
          d="M46.66,61.92a5.28,5.28,0,1,0-10.56,0v4H46.66Z" />
        <rect
          class="cls-3"
          x="32.14"
          y="36.68"
          width="40.92"
          height="5.43" />
        <polygon
          class="cls-4"
          points="75.7 48.72 29.5 48.72 32.15 42.12 73.06 42.12 75.7 48.72" />
        <path
          class="cls-4"
          d="M29.5,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-4"
          d="M36.1,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-4"
          d="M42.7,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-4"
          d="M49.3,48.72v2a3.3,3.3,0,1,0,6.6,0v-2Z" />
        <path
          class="cls-4"
          d="M55.9,48.72v2a3.3,3.3,0,1,0,6.6,0v-2Z" />
        <path
          class="cls-4"
          d="M62.5,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-4"
          d="M69.1,48.72v2a3.3,3.3,0,1,0,6.6,0v-2Z" />
        <rect
          class="cls-4"
          x="36.1"
          y="65.88"
          width="10.56"
          height="6.6" />
        <path
          class="cls-4"
          d="M65.8,54a3.3,3.3,0,0,1-3.23-2.64h-.13a3.3,3.3,0,0,1-6.47,0h-.13a3.29,3.29,0,0,1-5.22,2v14.1a1.11,1.11,0,0,0,1.1,1.1H68a1.1,1.1,0,0,0,1.1-1.1V51.35H69A3.3,3.3,0,0,1,65.8,54Z" />
        <path
          class="cls-3"
          d="M63.33,52.87a3.32,3.32,0,0,1-.76-1.52h-.13a3.3,3.3,0,0,1-6.47,0h-.13a3.29,3.29,0,0,1-5.22,2V65.58Z" />
        <path
          class="cls-3"
          d="M25.3,60.69c0,3.49-1.13,6.32-2.52,6.32s-2.52-2.83-2.52-6.32S22.78,48,22.78,48,25.3,57.2,25.3,60.69Z" />
        <rect
          class="cls-5"
          x="32.14"
          y="36.68"
          width="40.92"
          height="5.43" />
        <path
          class="cls-5"
          d="M72.4,54a3.3,3.3,0,0,1-3.3-3.3,3.3,3.3,0,0,1-6.6,0,3.3,3.3,0,1,1-6.6,0,3.3,3.3,0,1,1-6.6,0,3.3,3.3,0,0,1-6.6,0,3.3,3.3,0,0,1-6.6,0A3.29,3.29,0,0,1,32.8,54a3.68,3.68,0,0,1-.66-.06V72.47H73.06V53.93A3.52,3.52,0,0,1,72.4,54Z" />
        <path
          class="cls-5"
          d="M25.3,60.69c0,3.49-1.13,6.32-2.52,6.32s-2.52-2.83-2.52-6.32S22.78,48,22.78,48,25.3,57.2,25.3,60.69Z" />
        <line
          class="cls-6"
          x1="41.39"
          y1="56.64"
          x2="41.39"
          y2="72.47" />
        <line
          class="cls-6"
          x1="36.1"
          y1="61.92"
          x2="46.66"
          y2="61.92" />
        <polygon
          class="cls-5"
          points="75.7 48.72 29.5 48.72 32.15 42.12 73.06 42.12 75.7 48.72" />
        <path
          class="cls-5"
          d="M46.66,61.92a5.28,5.28,0,1,0-10.56,0v4H46.66Z" />
        <line
          class="cls-5"
          x1="41.39"
          y1="56.64"
          x2="41.39"
          y2="72.47" />
        <rect
          class="cls-5"
          x="36.1"
          y="65.88"
          width="10.56"
          height="6.6" />
        <line
          class="cls-5"
          x1="36.1"
          y1="61.92"
          x2="46.66"
          y2="61.92" />
        <path
          class="cls-5"
          d="M29.5,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M36.1,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M42.7,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M49.3,48.72v2a3.3,3.3,0,1,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M55.9,48.72v2a3.3,3.3,0,1,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M62.5,48.72v2a3.3,3.3,0,0,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M69.1,48.72v2a3.3,3.3,0,1,0,6.6,0v-2Z" />
        <path
          class="cls-5"
          d="M65.8,54a3.3,3.3,0,0,1-3.23-2.64h-.13a3.3,3.3,0,0,1-6.47,0h-.13a3.29,3.29,0,0,1-5.22,2v14.1a1.11,1.11,0,0,0,1.1,1.1H68a1.1,1.1,0,0,0,1.1-1.1V51.35H69A3.3,3.3,0,0,1,65.8,54Z" />
        <path
          class="cls-7"
          d="M84.39,19.34a2.56,2.56,0,0,0-1,.19,4.38,4.38,0,0,0-8.65,0,2.56,2.56,0,0,0-1-.19,2.64,2.64,0,1,0,0,5.28H84.39a2.64,2.64,0,1,0,0-5.28Z" />
        <path
          class="cls-8"
          d="M84.39,19.34a2.56,2.56,0,0,0-1,.19,4.38,4.38,0,0,0-8.65,0,2.56,2.56,0,0,0-1-.19,2.64,2.64,0,1,0,0,5.28H84.39a2.64,2.64,0,1,0,0-5.28Z" />
        <line
          class="cls-5"
          x1="22.78"
          y1="67.01"
          x2="22.78"
          y2="72.47" />
        <rect
          class="cls-8"
          x="30.82"
          y="32.98"
          width="43.56"
          height="3.71"
          rx="0.5"
          ry="0.5" />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconAudienceSegmentPlaceVisitors',
  };
</script>

<style lang="scss" scoped>
  @use '@/styles/variables' as *;

  .cls-1 {
    fill: var(--iconColorFaded9);
  }

  .cls-2,
  .cls-5,
  .cls-6 {
    fill: none;
  }

  .cls-2,
  .cls-5,
  .cls-6,
  .cls-7,
  .cls-8 {
    stroke: var(--iconColor);
  }

  .cls-2 {
    stroke-linecap: round;
  }

  .cls-2,
  .cls-5,
  .cls-8 {
    stroke-linejoin: round;
  }

  .cls-3,
  .cls-7,
  .cls-8 {
    fill: #fff;
  }

  .cls-4 {
    fill: var(--iconColorFaded6);
  }

  .cls-6,
  .cls-7 {
    stroke-miterlimit: 10;
  }
</style>
